import React from "react";

import Box from "grommet/components/Box";
import Heading from "grommet/components/Heading";

import Total from "./total";
import Legend from "./legend";
import { translate } from "react-i18next";
import AppSettings from "../../utils/appSettings";
import Label from "grommet/components/Label";
import Value from "grommet/components/Value";
import currencyFormatter from "currency-formatter";

const ViewerOneCategory = ({ t, stretch, i18n, series, option, baseCalcul, computationAppName }) => {
  let sum = 0;
  series.forEach(s => (sum += s.value));

  return (
    <Box align="center" pad={{ between: "large" }} alignSelf="stretch">
      {computationAppName ? (
        <Box margin="large">
          <Heading tag="h2">{computationAppName}</Heading>
        </Box>
      ) : null}
      <Box
          margin={{ vertical: "small" }}
          pad={{ between: "medium" }}
          responsive={true}
          direction="row"
          justify="between"
          align="center"
          flex={true}
        >
          <Heading tag="h2" style={{marginBottom: 0}}>
            {t("Total")}:
          </Heading>
          <Value
            value={currencyFormatter.format(
              sum,
              AppSettings.currencyOptionFormater
            )}
            units="€"
            size="medium"
          />
        </Box>

      <Box alignSelf={stretch ? "stretch" : "center"}>
        {baseCalcul !== undefined ? (
          <Box
            margin={{ vertical: "small" }}
            padding={{ horizontal: "medium" }}
            responsive={true}
            direction="row"
            justify="between"
            align="center"
            flex={true}
          >
            <Label size="medium" strong style={{ margin: 0 }}>
              {t("Base de calcul")}:
            </Label>
            <Value
              value={currencyFormatter.format(
                baseCalcul,
                AppSettings.currencyOptionFormater
              )}
              units="€"
              size="small"
            />
          </Box>
        ) : (
          undefined
        )}
        <Box alignSelf={stretch ? "stretch" : "center"}>
          <Box margin={{ vertical: "small" }}>
                <Heading
                  strong={true}
                  tag="h4"
                  truncate={false}
                  uppercase={true}
                >
                  {option.title}
                </Heading>
                <Legend
                  i18n={i18n}
                  series={series}
                  units="€"
                  total={false}
                />

            <Total label={option.totalLabel} total={sum} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default translate()(ViewerOneCategory);



// WEBPACK FOOTER //
// ./src/computationApps/components/viewer/ViewerOneCategory.js